<template>
	<div :id="uid" class="results-card-item">
		<div class="results-card-item__body">
			<Anchor
				class="link"
				:labelText="form.formName"
				@click.prevent="redirectToEditForm"
			/>
		</div>
	</div>
</template>
<script>
import Anchor from '@/site-components/anchor/anchor';

export default {
	name: 'SnippetCardForm',
	components: {
		Anchor
	},
	props: {
		form: {
			type: Object,
			default: () => {}
		}
	},
	methods: {
		redirectToEditForm() {
			this.$store.dispatch('codemanager/codeSelectedDetails', {});
			this.$store.dispatch('codemanager/showFormsModal', false);
			const self = this;
			self.$router.push({
				name: `impact-form-edit-designer`,
				params: { id: self.form.formId }
			});
		}
	}
};
</script>
<style lang="scss">
@import '@/scss/5-objects/_cards.scss';

.results-card-item {
	font-size: $default-font-size - 2;
	display: flex;
	gap: $gutter-md;

	&__state {
		@include vertical-horizontal-center-with-flex;
		@include create-circle(16px, 16px, $ui-positive);
		z-index: 20;
		color: white;

		.icon {
			font-size: 16px;
		}
	}

	&__body {
		width: calc(100% - 24px);
		display: flex;
		flex-wrap: wrap;
		row-gap: $gutter-md;
		@include mq($from: lg) {
			position: relative;
			row-gap: initial;
		}
	}

	&__main {
		width: 100%;
		font-size: $default-font-size;
		@include mq($from: lg) {
			display: flex;
			width: calc(100% - 100px);
		}
	}

	&__name {
		font-weight: $medium-font-weight;
		margin-bottom: $gutter-sm;
		line-height: 18px;

		@include mq($from: lg) {
			margin-bottom: 0;
			max-width: 170px;
			@include ellipsis;
		}
	}

	&__revision {
		@include mq($from: lg) {
			padding-left: $padding-sm;
		}
	}

	&__type {
		font-weight: $medium-font-weight;
		color: $neutral-1;
		@include mq($from: lg) {
			position: absolute;
			right: 0;
			top: 0;
			line-height: 18px;
		}
	}

	&__description {
		width: 100%;
		font: inherit;
		line-height: 16px;
		max-height: 16px;
		overflow: hidden;
		@include mq($from: lg) {
			max-width: calc(100% - 100px);
			margin-top: $gutter-sm;
		}
	}

	&__customers-container {
		width: 100%;
		@include mq($from: lg) {
			display: flex;
			margin-top: $gutter-md;
			width: calc(100% - 100px);
		}
	}

	&__customers-label {
		font: inherit;
		color: $ui-disable;
		@include mq($from: lg) {
			min-width: 170px;
		}
	}
	&__customers-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		font: inherit;
		margin-top: $gutter-md;

		@include mq($from: lg) {
			width: auto;
			margin-top: 0;
			padding-left: $padding-sm;
		}
	}

	&__action {
		width: 100%;
		display: inline-flex;
		justify-content: flex-end;
		margin-top: $gutter-md;
		@include mq($from: lg) {
			width: auto;
			margin-top: 0;
			position: absolute;
			right: 0;
			bottom: 0;
		}
	}
}
</style>
